import { Group } from '@/components/_common';
import { CustomerVehicleReduced } from '@/core/domain/people/CustomerVehicles/CustomerVehicles.types';
import { useCustomerDetailReduced } from '@/core/domain/people/Customers/Customers.hooks';
import { Alert, Button, Card } from 'antd';
import { FaCar, FaLink, FaPlus, FaUser } from 'react-icons/fa';
import VisionLinkVehicle from '../VisionLinkVehicle';
import { useDisclosure } from '@/hooks';
import { useState } from 'react';
import './styles.less';

interface Props {
  licensePlate?: string;
  vehicle?: CustomerVehicleReduced;
}

export default function VisionCustomerDetail(props: Props) {
  const customerDetail = useCustomerDetailReduced(props.vehicle?.customerId);

  const [linkinOpened, linkingAction] = useDisclosure(false, {
    onClose: () => setCreateUser(false),
  });
  const [createUser, setCreateUser] = useState(false);

  const loading = customerDetail.isLoading;

  return (
    <div>
      {!customerDetail.data && (
        <Alert
          style={{ borderRadius: 8 }}
          type="warning"
          message={<strong>Veículo não cadastrado</strong>}
          description={
            <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
              <span>
                Verificamos que este veículo não está cadastrado em sua base,
                você pode vincular a um cliente existente, ou criar um novo
                cliente com o veículo.
              </span>

              <Group gap={24} style={{ flexWrap: 'wrap' }}>
                <Button block onClick={linkingAction.open}>
                  <Group position="center">
                    <FaLink size={12} />
                    <span>Vincular veículo</span>
                  </Group>
                </Button>

                <Button
                  block
                  onClick={() => {
                    setCreateUser(true);
                    linkingAction.open();
                  }}
                >
                  <Group position="center">
                    <FaPlus size={12} />
                    <span>Cadastrar cliente</span>
                  </Group>
                </Button>
              </Group>
            </div>
          }
        />
      )}

      {!!customerDetail.data && (
        <Card loading={loading} style={{ borderRadius: 8 }}>
          <Group gap={24} className="customer-detail">
            <Group gap={16}>
              <div style={{ flexShrink: 0 }}>
                <FaUser size={24} />
              </div>

              <div>
                <div style={{ fontSize: 14, color: 'darkgray', lineHeight: 1 }}>
                  Cliente
                </div>
                <strong>{customerDetail.data?.name} </strong>
              </div>
            </Group>

            <Group gap={16}>
              <div style={{ flexShrink: 0 }}>
                <FaCar size={24} />
              </div>

              <div>
                <div style={{ fontSize: 14, color: 'darkgray', lineHeight: 1 }}>
                  Veículo
                </div>
                <strong>{`${props.vehicle?.licensePlate} • ${props.vehicle?.modelName}`}</strong>
              </div>
            </Group>
          </Group>
        </Card>
      )}

      <VisionLinkVehicle
        opened={linkinOpened}
        onClose={linkingAction.close}
        licensePlate={props.licensePlate}
        createUser={createUser}
      />
    </div>
  );
}
